import React from "react";
import { SectionTabs, type SectionTab } from "@cms/ui/components/section-tabs";

// The Forms section's tabs: the Inbox (submissions visitors have sent) and the
// Forms builder (create/manage form definitions). Exact matches so the
// per-form builder (/forms/:id) leaves both unlit.
const FORMS_TABS: SectionTab[] = [
  { label: "Inbox", href: "/forms", end: true },
  { label: "Forms", href: "/forms/build", end: true },
];

/**
 * The Forms section's sticky tab header (Inbox / Forms). Page actions render
 * beside the heading via PageHeader's `actions` slot, not here.
 */
export function FormsHeader() {
  return <SectionTabs sticky items={FORMS_TABS} />;
}
